import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  title: {
    margin: 0,
    fontSize: theme.typography.pxToRem(32),
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary,
  },
  description: {
    fontSize: theme.typography.pxToRem(13),
  },
  back: {
    fontSize: theme.typography.pxToRem(13),
    borderRadius: "4px",
    "& svg": {
      fontSize: theme.typography.pxToRem(13),
    },
  },
}));

export default useStyles;
